var PURCHASE_IN_APPSOURCE_LINK = 'https://learn.microsoft.com/{0}/marketplace';
var ISV_LINK = 'https://www.microsoft.com/{0}/isv/marketplace';
var BLOG_LOCATION_LINK = '/blog';
var CONTACT_US_LINK = 'https://support.microsoft.com/contactus';

export { BLOG_LOCATION_LINK, CONTACT_US_LINK, ISV_LINK, PURCHASE_IN_APPSOURCE_LINK };
